/**
 * Employee Rewards related pages.
 */
import { generateTechTask } from '@/helpers/generated-tech-task'
import { RouteGroup } from '@/types/routing-types'


export default [
    generateTechTask('Budgeting Settings', 'employee-rewards-settings', RouteGroup.EMP_REW)
]
